export class More{
	init(){
		$('.more-text a').click(function(e) {
			e.preventDefault();
			$(this).closest('.ex-text').siblings('.ex-text').slideDown();
		})
	}
}